export default {"src":"/_next/static/media/VYNE.46aee429.svg","height":18,"width":18};